import React, { useState } from 'react';
import P, { InferProps } from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import Container from '@mui/material/Container';
import CardHeader from '@mui/material/CardHeader';
import { SxStyle } from '../../../types';
import Grid from '@mui/material/Grid';

import { Field } from '../../../types';
import { MODULE_TYPES } from './types';
import RenderModuleField from '../../common/fields/render-fields';
import PromoModuleTitle from './components/promo-module-title';

const styles: SxStyle = {
  action: {
    marginTop: 0,
    alignContent: 'center',
  },
  switch: {
    marginLeft: '-1px',
    marginTop: '-4px',
    marginBottom: '-4px',
  },
  switchLabel: {
    whiteSpace: 'nowrap',
  },
  container: {
    marginBottom: '20px',
    marginTop: '6px',
  },
  promoChip: {
    marginLeft: '6px',
    paddingLeft: '3px',
  },
};

const onExiting = () => {
  if (document.activeElement?.nodeName.toLowerCase() === 'input') {
    (document.activeElement as HTMLInputElement).blur();
  }
};

function Module({
  item,
  setChange,
  setValidation,
  path,
  onDelete,
  currentKey,
  index,
  pathParams,
  isReadOnly,
  isNonRemoveable,
  promos,
}: InferProps<typeof Module.propTypes>) {
  const [expand, setExpand] = useState(false);

  const handleOnDelete = () => {
    if (onDelete) {
      onDelete(currentKey, index);
    }
  };

  const handleExpandClick = () => {
    setExpand(!expand);
  };

  const getModuleTitle = () => {
    if (
      item.type === MODULE_TYPES.PROMO ||
      item.type === MODULE_TYPES.PROMO_VIDEO ||
      item.type === MODULE_TYPES.PROMO_IMAGES
    ) {
      return (
        <PromoModuleTitle title={item.name} type={item.type} fields={item.fields} promos={promos} />
      );
    } else {
      return item.name;
    }
  };

  return (
    <>
      <CardHeader
        title={getModuleTitle()}
        titleTypographyProps={{ variant: 'subtitle1' }}
        // sx={{ action: styles.action }}
        action={
          <>
            {!isReadOnly && !isNonRemoveable && (
              <IconButton onClick={handleOnDelete} size="small">
                <DeleteIcon color="error" />
              </IconButton>
            )}
            <IconButton onClick={handleExpandClick} size="small">
              <ExpandMoreIcon />
            </IconButton>
          </>
        }
      />
      <Collapse in={expand} unmountOnExit onExiting={onExiting}>
        <Container sx={styles.container}>
          <Grid container direction="column" spacing={4}>
            {item.fields?.map((field: Field, index: number) => (
              <Grid item key={field.key}>
                <RenderModuleField
                  field={field}
                  setChange={setChange}
                  setValidation={setValidation}
                  keyPath={`${path}.fields[${index}]`}
                  path={pathParams}
                />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Collapse>
    </>
  );
}

Module.propTypes = {
  item: P.shape({
    type: P.string.isRequired,
    name: P.string.isRequired,
    id: P.string,
    fields: P.any.isRequired,
    isNonRemoveable: P.bool,
  }).isRequired,
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  path: P.string.isRequired,
  onDelete: P.func,
  currentKey: P.string,
  index: P.number,
  pathParams: P.string.isRequired,
  isReadOnly: P.bool.isRequired,
  isNonRemoveable: P.bool.isRequired,
  promos: P.arrayOf(P.object),
};

export default Module;
